module.exports = __webpack_public_path__ + "img/diva.3c3d8b4b.svg";